import * as tslib_1 from "tslib";
import { prepareComposeViewState, openComposeWithViewState } from './openCompose';
import trySaveAndCloseCompose from './trySaveAndCloseCompose';
import { saveWithAction } from '../actions/trySaveMessage';
import datapoints from '../datapoints';
import ComposeTarget from '../store/schema/ComposeTarget';
import { createReplyFromReplyItem, createReplyItem } from '../utils/createReply';
import findInlineComposeViewState from '../utils/findInlineComposeViewState';
import { MailboxType } from 'owa-client-ids';
import { getStore } from 'owa-mail-store';
import { action } from 'satcheljs/lib/legacy';
import { userMailInteractionAction } from 'owa-mail-actions';
import { onComposeOpened } from 'owa-mail-actions/lib/composeActions';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { isDeepLink } from 'owa-popout';
import { isSelf } from '../utils/isSelf';
export function replyToMessageAndCreateViewState(referenceItemOrId, isReplyAll, useFullCompose, conversationId, body, instrumentationContexts, groupId, fullComposeTarget, attachmentFiles, initialComposeLogTraceId, smartReplyExtractionId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var viewState, tabViewEnabled, existingViewState, replyToMessageDatapoint, referenceItem, mailStore, items, replyItem, composeOperation, composeInitProps, composeInitProps, message, composeOpened;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    viewState = null;
                    tabViewEnabled = isTabViewEnabled();
                    if (fullComposeTarget === undefined) {
                        fullComposeTarget = tabViewEnabled
                            ? ComposeTarget.SecondaryTab
                            : ComposeTarget.PrimaryReadingPane;
                    }
                    if (!(!useFullCompose || !tabViewEnabled)) return [3 /*break*/, 2];
                    existingViewState = findInlineComposeViewState(conversationId);
                    if (!existingViewState) return [3 /*break*/, 2];
                    return [4 /*yield*/, trySaveAndCloseCompose(existingViewState)];
                case 1:
                    _a.sent();
                    // If there is still default compose viewstate, it means it is failed to save and close previous compose
                    // So no-op here
                    if (findInlineComposeViewState(conversationId)) {
                        return [2 /*return*/, Promise.resolve(null)];
                    }
                    _a.label = 2;
                case 2:
                    replyToMessageDatapoint = returnTopExecutingActionDatapoint();
                    // Datapoint is not present for unit tests
                    if (replyToMessageDatapoint) {
                        replyToMessageDatapoint.addCustomData({
                            initialComposeLogTraceId: initialComposeLogTraceId,
                        });
                    }
                    if (typeof referenceItemOrId === 'string') {
                        mailStore = getStore();
                        items = mailStore && mailStore.items;
                        if (items && items.has(referenceItemOrId)) {
                            referenceItem = items.get(referenceItemOrId);
                        }
                    }
                    else {
                        referenceItem = referenceItemOrId;
                    }
                    if (!referenceItem) return [3 /*break*/, 11];
                    // VSO 29873: when replying to your own message, by default you
                    // should replyAll
                    if (!isReplyAll && isSelf(referenceItem.From.Mailbox)) {
                        isReplyAll = true;
                    }
                    return [4 /*yield*/, createReplyItem(referenceItem, isReplyAll)];
                case 3:
                    replyItem = _a.sent();
                    composeOperation = isReplyAll ? 2 /* ReplyAll */ : 1 /* Reply */;
                    if (!(conversationId && !useFullCompose)) return [3 /*break*/, 6];
                    composeInitProps = {
                        operation: composeOperation,
                        bodyType: replyItem.NewBodyContent.BodyType,
                        subject: replyItem.Subject,
                        newContent: body,
                        to: replyItem.ToRecipients,
                        cc: replyItem.CcRecipients,
                        referenceItemId: referenceItem.ItemId,
                        referenceItemDocumentId: replyItem.ReferenceItemDocumentId,
                        conversationId: conversationId,
                        preferAsyncSend: true,
                        IRMData: referenceItem.RightsManagementLicenseData,
                        logTraceId: initialComposeLogTraceId,
                        smartReplyExtractionId: smartReplyExtractionId,
                    };
                    return [4 /*yield*/, prepareComposeViewState(composeInitProps, groupId, attachmentFiles)];
                case 4:
                    viewState = _a.sent();
                    return [4 /*yield*/, openComposeWithViewState(viewState, ComposeTarget.PrimaryReadingPane)];
                case 5:
                    _a.sent();
                    // Create the draft in background to prepare for upConvert
                    saveWithAction(viewState, createReplyFromReplyItem(replyItem, !!groupId /*useGroupAction*/).then(function (message) {
                        if (message) {
                            viewState.itemId = message.ItemId;
                            viewState.subject = message.Subject;
                            viewState.quotedBody = message.Body.Value;
                        }
                    }));
                    return [3 /*break*/, 10];
                case 6:
                    composeInitProps = {
                        operation: composeOperation,
                        bodyType: replyItem.NewBodyContent.BodyType,
                        subject: replyItem.Subject,
                        newContent: body,
                        to: replyItem.ToRecipients,
                        cc: replyItem.CcRecipients,
                        bcc: replyItem.BccRecipients,
                        referenceItemId: referenceItem.ItemId,
                        preferAsyncSend: true,
                        IRMData: referenceItem.RightsManagementLicenseData,
                        useSmartResponse: true,
                        logTraceId: initialComposeLogTraceId,
                        isPopout: isDeepLink(),
                    };
                    return [4 /*yield*/, createReplyFromReplyItem(replyItem, !!groupId /*useGroupAction*/)];
                case 7:
                    message = _a.sent();
                    if (message) {
                        composeInitProps.itemId = message.ItemId;
                        composeInitProps.quotedBody = message.Body.Value;
                        composeInitProps.attachments = message.Attachments;
                        composeInitProps.useSmartResponse = false; // Quoted body is loaded, no need to use smart response now
                    }
                    return [4 /*yield*/, prepareComposeViewState(composeInitProps, groupId, attachmentFiles)];
                case 8:
                    viewState = _a.sent();
                    return [4 /*yield*/, openComposeWithViewState(viewState, fullComposeTarget)];
                case 9:
                    composeOpened = _a.sent();
                    if (composeOpened) {
                        onComposeOpened();
                    }
                    _a.label = 10;
                case 10:
                    isReplyAll
                        ? userMailInteractionAction('ReplyAll', instrumentationContexts)
                        : userMailInteractionAction('Reply', instrumentationContexts);
                    _a.label = 11;
                case 11: return [2 /*return*/, viewState];
            }
        });
    });
}
// We need to have two entrance for reply and replyAll since they are using different datapoint name
var replyToMessageAction = action('replyToMessage', datapoints.MailComposeReply)(function replyToMessageAction(referenceItemId, useFullCompose, conversationId, body, actionSource, instrumentationContexts, groupId, fullComposeTarget, attachmentFiles, initialComposeLogTraceId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, replyToMessageAndCreateViewState(referenceItemId, false /* isReplyAll */, useFullCompose, conversationId, body, instrumentationContexts, groupId, fullComposeTarget, attachmentFiles, initialComposeLogTraceId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
var replyAllToMessageAction = action('replyAllToMessage', datapoints.MailComposeReplyAll)(function replyAllToMessageAction(referenceItemId, useFullCompose, conversationId, body, actionSource, instrumentationContexts, groupId, fullComposeTarget, attachmentFiles, initialComposeLogTraceId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, replyToMessageAndCreateViewState(referenceItemId, true /* isReplyAll */, useFullCompose, conversationId, body, instrumentationContexts, groupId, fullComposeTarget, attachmentFiles, initialComposeLogTraceId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
export default function replyToMessage(referenceItemId, isReplyAll, useFullCompose, actionSource, instrumentationContexts, conversationId, body, fullComposeTarget, attachmentFiles, initialComposeLogTraceId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var mailboxInfo, groupId;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    mailboxInfo = referenceItemId.mailboxInfo;
                    groupId = mailboxInfo && mailboxInfo.type == MailboxType.GroupMailbox ? mailboxInfo.mailboxId : null;
                    if (!isReplyAll) return [3 /*break*/, 2];
                    return [4 /*yield*/, replyAllToMessageAction(referenceItemId.Id, useFullCompose, conversationId, body, actionSource, instrumentationContexts, groupId, fullComposeTarget, attachmentFiles, initialComposeLogTraceId)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [4 /*yield*/, replyToMessageAction(referenceItemId.Id, useFullCompose, conversationId, body, actionSource, instrumentationContexts, groupId, fullComposeTarget, attachmentFiles, initialComposeLogTraceId)];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=replyToMessage.js.map